import styled from 'styled-components';

import TertiaryButton from 'components/v2/Button/TertiaryButton';
import { COLORS } from 'theme';

export const StyledClearFilterButton = styled(TertiaryButton)`
  &&& {
    padding: ${({ theme }) => theme.spacing.s2};
    border: 1px solid ${COLORS.black10};
    svg {
      path {
        fill: ${COLORS.black50};
      }
    }

    &:hover {
      background-color: ${`${COLORS.black30}1A`};
      border: 1px solid ${`${COLORS.black30}1A`};
    }
  }
`;
